import { TrackingClient } from '@sparefoot/tracking-client';
import { lifecycle, compose } from 'recompose';

function withPageViewTracking(pageTypeOrFn) {
	return compose(
		lifecycle({
			componentDidMount() {
				if (typeof window !== 'undefined' && TrackingClient) {
					const resolvedPageType =
						typeof pageTypeOrFn === 'function'
							? pageTypeOrFn(this.props)
							: pageTypeOrFn;
					const metaTitle = document.title || resolvedPageType;
					TrackingClient.trackPageView({
						page_name: metaTitle,
						page_type: resolvedPageType,
					});
				}
			},
		}),
	);
}

export default withPageViewTracking;
